// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".message-wrap[data-v-2d49727a]{position:relative;width:100%;padding:17px 40px 17px 20px;background:#fde9e9;border:1px dashed #ffb7b7;box-sizing:border-box;border-radius:10px;font-weight:400;font-size:.92857rem;line-height:.85714rem;color:#0f2345}.close[data-v-2d49727a]{position:absolute;top:calc(50% - 5px);right:20px;fill:#ffb7b7;cursor:pointer}", ""]);
// Exports
module.exports = exports;
